import { Button, checkbox, Checkbox, Dialog, DialogFooter, DialogHeader } from "@material-tailwind/react"
import { UseMutateFunction, useMutation } from "@tanstack/react-query"
import useAuth from "hooks/useAuth"
import { ChangeEvent, useState } from "react"
import ts, { Map } from "typescript"
import { ReactSetterType } from "utils/types"
import Holdable from "./utils/Holdable"

type Prop = {
    headers : string[]
    data : {
        key : number,
        submittedBy : number,
        data : any[]
    }[] | null,
    setSelected : ReactSetterType<{[x:number] : boolean}>,
    onClick : (target :number)=>void
    selected: {[x:number] : boolean},
    handleDestroy : ()=>void
}


export class ClickableData{
    constructor(public data : boolean, public onClick : (e:ChangeEvent<HTMLInputElement>)=>void){}
}

const AdminTable = ({
        headers,
        data,
        selected,
        setSelected,
        onClick,
        handleDestroy
    }: Prop)=>{

    const [destroyConfirm, setDestroyConfirm] = useState(false);
    const {auth} = useAuth(); 

    const handleChange=(item : number)=> {
        setSelected(prev =>({...prev, [item] : !prev[item]}));
    }

    const headersElement = headers.map((head, index)=>(
        <th key={index} className=" border-b font-medium p-4 pl-8 pt-0 pb-3 
        text-slate-400 text-left">{head}</th>
    ))
    
    const dataElement = data?.map(datum=>(
        <Holdable 
            className={"relative group " + (selected[datum.key] && "bg-sky-100 text-slate-800") + (datum.submittedBy === auth?.id || auth?.isAdmin ? " cursor-pointer hover:bg-blue-50 " : "")} 
            key={datum.key} 
            onHold={(e :any)=>handleChange(datum.key)}
            onClick={(e)=>{
                let cancleEventFlag = false;

                // @ts-ignore
                e.target.className.split(" ").forEach((className : string)=>{
                    switch(className){
                        case `allow-click`:
                            cancleEventFlag = true;
                    }
                })

                if(cancleEventFlag)
                    return;

                if(!(datum.submittedBy === auth?.id) && !(auth?.isAdmin))
                    return
                    
                if(Object.entries(selected).every(el=>!el[1])){
                    onClick(datum.key)
                    return;
                }

                selected[datum.key] && handleChange(datum.key)
            }}
        >
            <tr>
                {datum.data.map((value, index)=>(
                    <td key={index} className={"border-b border-slate-100 p-4 pl-8 " +  (!selected[datum.key] && "text-slate-500")}>
                        { index === 0 &&
                            <div className={"absolute top-1/2 transform -translate-y-1/2 p-2 -left-12 " + (Object.entries(selected).some((el)=>el[1]) ? " md:block" : " hidden md:group-hover:block")}>
                                <Checkbox className="bg-white allow-click" id={`checkbox-${datum.key}`} checked={selected[datum.key] || false} onChange={(e)=>{handleChange(datum.key)}}>
                                </Checkbox>
                            </div>
                        }
                        <div>
                            {value instanceof ClickableData ? <>
                                <Checkbox checked={value.data} onChange={value.onClick} className=" relative allow-click"/>
                            </>
                             : value}
                        </div>
                    </td>
                ))}
            </tr>
        </Holdable>
    ))


    return (
        <>
        <Dialog open={destroyConfirm} handler={()=>setDestroyConfirm(false)}>
          <DialogHeader>Are you sure to delete these items?</DialogHeader>
          <DialogFooter>
            <Button
              variant="text"
              color="red"
              onClick={()=>{setDestroyConfirm(false);}}
              className="mr-1"
            >
              <span>Cancel</span>
            </Button>
            <Button variant="gradient" color="red" onClick={()=>{setDestroyConfirm(false); handleDestroy()}}>
              <span>Confirm</span>
            </Button>
          </DialogFooter>
        </Dialog>
        <div className="mt-4 -mb-3">
            <div className={"not-prose relative bg-slate-50 rounded-xl pt-1 ml-10 transform transition-transform" +
                    (!Object.entries(selected).some((el)=>el[1]) ? " -translate-x-7" : " translate-x-0")}>
                {!dataElement &&
                    <div className="absolute bg-white opacity-20 w-full h-full">
                    </div>
                }
                <div className="shadow-sm mt-8 relative">
                    { (Object.entries(selected).some((el)=>el[1]) &&
                        <div className=" absolute -left-12 -top-2">
                            <Button color="red" className="py-3" size="sm" onClick={()=>setDestroyConfirm(true)}>
                                <i className="fas fa-trash text-white"></i>
                            </Button>
                        </div>
                    ) }
                    <table className="border-collapse table-auto w-full text-sm">
                        <thead>
                            <tr>
                                {headersElement}
                            </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-slate-800">
                            {dataElement ? dataElement : <tr><td>Loading...</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        </>
    )
}

export default AdminTable